module.exports = __webpack_public_path__ + "img/change_vendor_character.ba81a19b.png";